import React, { useState } from "react";
import { exampleService } from "../../services/example.service";

import IconButton from "@mui/material/IconButton";
import SendIcon from '@mui/icons-material/Send';
import Textarea from "@mui/joy/Textarea";

export default function AddComment(props) {
  const [text, setText] = useState("");

  function handleGetText(event) {
    setText(event.target.value);
  }
  async function handleSubmitForm(e) {
    e.preventDefault();
    await exampleService.createComment({
      text,
      postId: props.fileId,
    });
    props.handleGetAllComments();
    setText("");
  }
  return (
    <>
      <form onSubmit={handleSubmitForm} style={{ display: 'flex', flexDirection: "row", alignItems: 'center' }}>
        <Textarea
          placeholder="Type something ...."
          color="primary"
          minRows={2}
          size="lg"
          variant="outlined"
          onChange={handleGetText}
          value={text}
          name="text"
          id="text"
          required
          style={{ marginRight: '10px', flexGrow: '1' }}
        />
        <IconButton type="submit" color="primary"><SendIcon/></IconButton>
      </form>
    </>
  );
}
